module.exports = __webpack_public_path__ + "static/media/petAss.6af882e0.svg";